import { 
    createSlice, 
    createAsyncThunk,  
    createEntityAdapter,
    createSelector,  
} from '@reduxjs/toolkit'
import { Pager } from '../../../lib/js-apiclient/src/response/Pager';
import { FarfetchModel } from '../models/farfetch/FarfetchModel';


const farfetchGenderAdapter = createEntityAdapter({})

export const farfetchGenderApi = {
    _model: null,
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'farfetch/gender/fetchAll', 
        async ({channelId, page, term}, thunkAPI) => {
            try {
                const token = farfetchGenderApi._getToken(thunkAPI);
                const farfetchModel = new FarfetchModel(token, channelId);

                /** @type {Pager} */
                const pager = await farfetchModel.getGenders(page, term);
                
                return {
                    hasPrevPage: pager.hasPrevPage,
                    hasNextPage: pager.hasNextPage,
                    entities: pager.getEntities()
                }
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const farfetchGenderSlice = createSlice({
    name: "farfetch/gender",
    initialState: farfetchGenderAdapter.getInitialState({
        status: 'idle',
        error: null,
        showMore: true,
    }),
    reducers: {
        clearGenderList(state, action) {
            farfetchGenderAdapter.removeAll(state);
        },
    },
    extraReducers: {
        [farfetchGenderApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'farfetch/gender/fetchAll/succeeded'

            if(action.payload.hasPrevPage) {
                farfetchGenderAdapter.addMany(state, action.payload.entities)
            } else {
                farfetchGenderAdapter.setAll(state, action.payload.entities)
            }

            state.showMore = action.payload.hasNextPage;
            state.error = null;
        },
        [farfetchGenderApi.fetchAll.rejected]: (state, action) => {
            state.status = 'farfetch/gender/fetchAll/rejected'
            state.error = action.payload
        },
    }
});

export const selectFarfetchGenders = createSelector(
    (state, _) => selectAllFarfetchGenders(state),
    (_, filter) => filter,
    (items, filter) => {
        return (filter !== undefined && filter !== null && filter !== null) 
            ? items.filter((item) => {
                return item.name.startsWith(filter);
              })
            : items
    }
  );

export const {
    selectAll: selectAllFarfetchGenders,
} = farfetchGenderAdapter.getSelectors((state) => state.farfetchGenderReducer)

export const { clearGenderList } = farfetchGenderSlice.actions;

export default farfetchGenderSlice.reducer;
